import {Tooltip, styled, Icon, theme} from "@reside/ui";
import {useState, useEffect} from "react";

export const StonlyButton = () => {
  const [isWidgetAvailable, setIsWidgetAvailable] = useState(false);

  useEffect(() => {
    // Check if the Stonly widget is available
    if (window && (window as any)?.StonlyWidget) {
      setIsWidgetAvailable(true);
      return null;
    } else {
      // Check again after a short delay in case it's still loading
      const checkInterval = setInterval(() => {
        if (window && (window as any)?.StonlyWidget) {
          setIsWidgetAvailable(true);
          clearInterval(checkInterval);
        }
      }, 500);

      // Clear interval after 5 seconds to avoid checking indefinitely
      setTimeout(() => {
        clearInterval(checkInterval);
      }, 5000);

      return () => clearInterval(checkInterval);
    }
  }, []);

  if (!isWidgetAvailable) return null;

  return (
    <CustomTooltip content="Need Help?">
      <Button
        type="button"
        id="stonly-help-button"
        aria-label="help button - need some help?"
      >
        <Icon
          name="help-circled-alt"
          size={25}
          color={theme.color.darkBlue100}
        />
      </Button>
    </CustomTooltip>
  );
};

const CustomTooltip = styled(Tooltip)`
  margin-right: ${({theme}: any) => theme.space[5]}px;
`;

const Button = styled.button`
  border: 0;
  padding: 0;
  background-color: transparent;
  cursor: pointer;
`;
